var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCo = function SvgIconCo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12l-12 1.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M1.605 18C3.68 21.587 7.558 24 12 24s8.319-2.413 10.394-6L12 17.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M22.394 18A11.94 11.94 0 0 0 24 12H0c0 2.186.585 4.235 1.606 6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCo;